import { useProductPickerStore } from '../composable/useProductPickerStore';

export const useInfiniteScroll = () => {
  const { isLoading, isRefresh, query, fetchedAll, fetchedAllQuery } = useProductPickerStore();

  const isFetchMore = computed(() => {
    return !fetchedAll.value && query.value.length == 0 && !isLoading.value && !isRefresh.value;
  });

  const isFetchMoreQuery = computed(() => {
    return !fetchedAllQuery.value && query.value.length > 0 && !isLoading.value && !isRefresh.value;
  });

  return { isFetchMore, isFetchMoreQuery };
};
